import {AccessLogSummary} from './Inc';

const chartSummaryName = (summary:AccessLogSummary): JSX.Element => {
	if( summary.key.startsWith("URL") ){
		return <p style={{display:'flex',margin:'0',gap:'0.5rem',alignItems:'center'}}><span>{summary.key}</span><span style={{color:'teal',fontSize:'90%',lineHeight:'1rem',wordBreak:"break-all"}}>{summary.value}</span></p>;
	}
	if( summary.key==="none" || summary.key==="AndroidApp" || summary.key==="redirect" || summary.key==="internal" ){
		return <span>{getSummaryName(summary.key)}</span>;
	}
	return <span>{summary.key}</span>;
};

export const getSummaryName = (key: string): string => {
	if( key==="none" ){
		return "なし";
	}
	if( key==="AndroidApp" ){
		return "アプリ";
	}
	if( key==="redirect" ){
		return "旧URL";
	}
	if( key==="internal" ){
		return "ストア内";
	}
	if( key==="tron" ){
		return "架空ブログ";
	}
	return key;
}

export default chartSummaryName;